import React, { useEffect, useState } from 'react'
import * as styles from "./styles/imageholder.module.css";
import { Image } from 'semantic-ui-react';

const FALLBACK_IMAGE = "https://cdn.ngnw.ph/logo-product.png";

const ImageHolder = (props) => {
    const {
        heightToWidthRatio,
        imageHolderClassname = "",
        imageLoading = false,
        displayMode = "default",
        responsive = false,

        src,
        className = "",
        ...imageProps
    } = props;

    // heightToWidthRatio = (Height / Width)
    // Padding Bottom Percentage = heightToWidthRatio * 100
    // E.g. (400 / 500) * 100 = 80%
    const paddingBottomPercentage = `${(heightToWidthRatio * 100).toFixed(2)}%`;

    const getValidSrc = (src) => {
        return typeof src === "string"
            ? src.trim() !== ''
                ? src
                : FALLBACK_IMAGE
            : FALLBACK_IMAGE
    };

    const [imageSrc, setImageSrc] = useState(getValidSrc(src));
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setImageSrc(getValidSrc(src));
        setHasError(false);
    }, [src])

    let srcSet;

    if (imageSrc !== FALLBACK_IMAGE && responsive === true && imageProps.sizes !== undefined) {
        let fullUrl = imageSrc;

        if (fullUrl.includes("/full/")) {
            let highUrl = fullUrl.replace("/full/", "/high/");
            let medUrl = fullUrl.replace("/full/", "/med/");
            let thumbUrl = fullUrl.replace("/full/", "/thumb/")

            srcSet = `${encodeURI(thumbUrl)} 200w, ${encodeURI(medUrl)} 512w, ${encodeURI(highUrl)} 1024w, ${encodeURI(fullUrl)} 2048w`.trim();
        }
    }

    const handleImageError = (e) => {
        // Prevent infinite loop, when even the fallback image fails
        if (!hasError && imageSrc !== FALLBACK_IMAGE) {
            setHasError(true);
            setImageSrc(FALLBACK_IMAGE);
        }
    }

    return (
        <div className={`${styles.imageHolder} ${imageHolderClassname}`} style={{ paddingBottom: paddingBottomPercentage }}>
            {displayMode === "default" &&
                <Image
                    {...imageProps}
                    src={imageSrc}
                    {...(srcSet !== undefined ? { srcSet } : {})}
                    className={`${className} ${hasError ? styles.imageLoading : ''}`}
                    onError={handleImageError}
                />
            }
            {displayMode === "loading" &&
                <Image {...imageProps} src="https://cdn.ngnw.ph/loading-square.gif" className={`${className} ${styles.imageLoading}`} />
            }

            {/* other display mode... */}
        </div>
    )
}

export default ImageHolder